import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import Calendar from 'react-calendar'; // Remove react-calendar
// import 'react-calendar/dist/Calendar.css'; // Remove react-calendar CSS
import { Calendar, momentLocalizer } from 'react-big-calendar'; // Import react-big-calendar
import moment from 'moment'; // Import moment
import 'moment/locale/sv'; // Import Swedish locale for moment
import 'react-big-calendar/lib/css/react-big-calendar.css'; // Import react-big-calendar CSS
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import sv from 'date-fns/locale/sv'; // Keep for DatePicker
import './App.css';
import './AppLayout.css'; // Import new CSS for layout

// Setup the localizer by providing the moment Object
moment.locale('sv');
const localizer = momentLocalizer(moment);

function App() {
  const [theme, setTheme] = useState('boden'); // Add theme state, default to 'boden'
  const [cars, setCars] = useState([]);
  const [selectedCar, setSelectedCar] = useState('');
  const [startDate, setStartDateTime] = useState(new Date());
  const [endDate, setEndDateTime] = useState(new Date());
  const [name, setName] = useState('');
  const [bookings, setBookings] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState(null); // State to hold the clicked booking details

  // Function to set the theme
  const changeTheme = (newTheme) => {
    setTheme(newTheme);
  };

  // Effect to update body class when theme changes
  useEffect(() => {
    // Remove previous theme classes
    document.body.classList.remove('theme-light', 'theme-dark', 'theme-ghibli', 'theme-boden');
    // Add the new theme class
    document.body.classList.add(`theme-${theme}`);
  }, [theme]); // Re-run effect when theme changes
  const combineDateAndTime = (date, time) => {
    if (!date || !time) {
      console.error('Invalid input to combineDateAndTime:', { date, time });
      return null; // Return null for invalid inputs
    }
  
    const [hours, minutes] = time.split(':');
    if (!hours || !minutes) {
      console.error('Invalid time format in combineDateAndTime:', time);
      return null;
    }
  
    const newDate = new Date(date);
    if (isNaN(newDate)) {
      console.error('Invalid date in combineDateAndTime:', date);
      return null;
    }
  
    newDate.setHours(parseInt(hours, 10));
    newDate.setMinutes(parseInt(minutes, 10));
    newDate.setSeconds(0);
    return newDate;
  };
  
  const formatTime = (date) => {
    if (!date || isNaN(new Date(date))) {
      console.error('Invalid date in formatTime:', date);
      return '00:00'; // Default time
    }
  
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    return `${hours}:${minutes}`;
  };
  
  // Safely generate startDateTime and endDateTime
  const startDateTime = combineDateAndTime(startDate, formatTime(startDate));
  const endDateTime = combineDateAndTime(endDate, formatTime(endDate));
  
  if (!startDateTime || !endDateTime) {
    console.error('Failed to generate startDateTime or endDateTime:', { startDateTime, endDateTime });
  }

  useEffect(() => {
    // Hämta bilar
    axios
      .get('/bilbokning/get_cars.php') // Ändra till rätt URL för ditt PHP-skript
      .then((response) => {
        setCars(response.data); // response.data innehåller bil-listan
        if (response.data.length > 0) {
          setSelectedCar(response.data[0].id); // Välj den första bilen automatiskt
        }
      })
      .catch((error) => {
        console.error('Fel vid hämtning av bilar:', error);
        alert('Kunde inte hämta bilarna. Vänligen försök igen.');
      });
  
    // Hämta bokningar
    axios
      .get('/bilbokning/get_bookings.php') // Ändra till rätt URL för ditt PHP-skript
      .then((response) => {
        setBookings(response.data); // response.data innehåller bokningslistan
      })
      .catch((error) => {
        console.error('Fel vid hämtning av bokningar:', error);
        alert('Kunde inte hämta bokningarna. Vänligen försök igen.');
      });
  }, []);
  
  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (!name) {
      alert('Vänligen ange ditt namn');
      return;
    }
    
    // Funktion för att formatera datum och tid
    const formatDateTime = (date) => {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    
    if (endDate <= startDateTime) {
      alert('Slutdatum och tid måste vara efter startdatum och tid.');
      return;
    }

    const formattedStart = formatDateTime(startDateTime);
    const formattedEnd = formatDateTime(endDateTime);
    
    const userPassword = prompt('Ange lösenord för att kunna ta bort bokningen:');
    if (!userPassword) {
      alert('Du måset ange ett lösenord.');
      return;
    }

    const booking = {
      car_id: selectedCar,
      user_name: name,
      start_datetime: formattedStart,
      end_datetime: formattedEnd,
      password: userPassword,
    };
  
    axios
    .post('/bilbokning/bookings.php', booking)
    .then((response) => {
      const newBooking = { ...booking, id: response.data.booking_id };
      setBookings((prevBookings) => [...prevBookings, newBooking]);
      setName('');
      setStartDateTime(new Date());
      setEndDateTime(new Date());
    })
    .catch((error) => {
      console.error('Error during booking:', error);
      alert('Could not complete the booking. Please try again.');
    });
  };
  
  // Remove state related to react-calendar
  // const [selectedDateBookings, setSelectedDateBookings] = useState([]);
  // const [selectedDate, setSelectedDate] = useState(null);

  // Remove handleDateClick for react-calendar
  // const handleDateClick = (date) => { ... };

  // Transform bookings into the format react-big-calendar expects
  const calendarEvents = bookings.map(booking => ({
    id: booking.id,
    title: `${cars.find(car => car.id === booking.car_id)?.name || 'Okänd'} - ${booking.user_name}`,
    start: new Date(booking.start_datetime),
    end: new Date(booking.end_datetime),
    resource: booking // Keep original booking data if needed
  }));

  // Handler for clicking on an existing event
  const handleSelectEvent = (event) => {
    // Find the original booking data using the event id
    const originalBooking = bookings.find(b => b.id === event.id);
    setSelectedBooking(originalBooking); // Set the selected booking to show details
    console.log('Selected Event:', event);
  };

  // Handler for selecting a time slot (optional, for future use like creating new bookings)
  const handleSelectSlot = (slotInfo) => {
    console.log('Selected Slot:', slotInfo);
    // Example: Could open a modal to create a new booking
    // setStartDateTime(slotInfo.start);
    // setEndDateTime(slotInfo.end);
    setSelectedBooking(null); // Clear details when selecting a slot
  };

  // Function to close the booking details view
  const closeBookingDetails = () => {
    setSelectedBooking(null);
  };

  const handleDeleteBooking = (bookingId) => {
    const userPassword = prompt('Ange lösenorder för att ta bort denna bokning:');
    if (!userPassword) return;

    axios
      .post('/bilbokning/delete_booking.php', { id: bookingId, password: userPassword }) // Use POST to send the booking ID
      .then((response) => {
        if (response.data.error) {
          alert('Kunde inte ta bort bokningen: ' + response.data.message);
        } else {
          alert('Bokning borttagen');
          // Uppdatera bokningar lokalt
          setBookings((prevBookings) => prevBookings.filter((booking) => booking.id !== bookingId));
          // Clear selected booking if it was the one deleted
          if (selectedBooking && selectedBooking.id === bookingId) {
            setSelectedBooking(null);
          }
        }
      })
      .catch((error) => {
        console.error('Fel vid borttagning:', error);
        alert('Kunde inte ta bort bokningen.');
      });
  };

  return (
    // Remove the theme class from the container
    <div className="container">
      {/* Theme switcher buttons */}
      <div className="theme-switcher">
        <button onClick={() => changeTheme('light')}>Light</button>
        <button onClick={() => changeTheme('dark')}>Dark</button>
        <button onClick={() => changeTheme('ghibli')}>Ghibli</button>
        <button onClick={() => changeTheme('boden')}>Boden</button> {/* Add Boden theme button */}
      </div>
             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
         <img src="/bilbokning/va-teknik2.png" alt="VA-Teknik Logo" style={{ height: '100px', width: 'auto' }} />
         <h1>Bilbokningssystem</h1>
       </div>
      <div className="app-layout"> {/* New wrapper for layout */}
        <div className="form-section"> {/* Wrapper for the form */}
      <form onSubmit={handleSubmit}>
    <div>
      <label>Välj en bil:</label>
      <select
        value={selectedCar}
        onChange={(e) => setSelectedCar(e.target.value)}
      >
        {cars.map((car) => (
          <option key={car.id} value={car.id}>
            {car.name}
          </option>
        ))}
      </select>
    </div>
    <div>
      <label>Startdatum och tid:</label>
      <DatePicker
        selected={startDate}
        onChange={(date) => setStartDateTime(date)}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        dateFormat="yyyy-MM-dd HH:mm"
        timeCaption="Tid"
        locale={sv}
      />
    </div>
    <div>
      <label>Slutdatum och tid:</label>
      <DatePicker
        selected={endDate}
        onChange={(date) => setEndDateTime(date)}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        dateFormat="yyyy-MM-dd HH:mm"
        timeCaption="Tid"
        locale={sv}
      />
    </div>
    <div>
      <label>Ditt namn:</label>
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
    </div>
          <button type="submit">Boka bil</button>
        </form>
      </div> {/* End form-section */}

      <div className="calendar-section"> {/* Wrapper for calendar and details */}
        <h2>Kalenderöversikt</h2>
        <div className="calendar-big"> {/* Use a different class for styling */}
          <Calendar
            localizer={localizer}
            events={calendarEvents}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 600 }} // Adjust height as needed
            views={['month', 'week', 'day', 'agenda']} // Specify desired views
            selectable // Allow selecting time slots
            onSelectEvent={handleSelectEvent} // Handle clicking an event
            onSelectSlot={handleSelectSlot} // Handle selecting a slot
            messages={{ // Optional: Translate calendar messages
              next: "Nästa",
              previous: "Föregående",
              today: "Idag",
              month: "Månad",
              week: "Vecka",
              day: "Dag",
              agenda: "Agenda",
              date: "Datum",
              time: "Tid",
              event: "Händelse",
              noEventsInRange: "Inga bokningar i detta intervall.",
              showMore: total => `+${total} till`,
            }}
          />
        </div>

        {/* Show details for the selected booking */}
        {selectedBooking && (
          <div className="booking-details">
            <h3>Bokningsdetaljer</h3>
             {/* Add a close button */}
            <button onClick={closeBookingDetails} className="close-details-btn">Stäng</button>
            <ul>
              <li> {/* Wrap details in a single li or structure differently */}
                <p>
                  <strong>Bil:</strong>{' '}
                  {cars.find((car) => car.id === selectedBooking.car_id)?.name || 'Okänd'}
                </p>
                <p>
                  <strong>Starttid:</strong> {new Date(selectedBooking.start_datetime).toLocaleString('sv-SE',{year: 'numeric',month: '2-digit',day: '2-digit',hour: '2-digit',minute: '2-digit'})}
                </p>
                <p>
                  <strong>Sluttid:</strong> {new Date(selectedBooking.end_datetime).toLocaleString('sv-SE',{year: 'numeric',month: '2-digit',day: '2-digit',hour: '2-digit',minute: '2-digit'})}
                </p>
                <p>
                  <strong>Bokad av:</strong> {selectedBooking.user_name}
                </p>
                <button onClick={() => handleDeleteBooking(selectedBooking.id)}>
                  Ta bort bokning
                </button>
              </li>
            </ul>
          </div>
        )}
        </div> {/* End calendar-section */}
      </div> {/* End app-layout */}
    </div>
  );
}

export default App;
